import { Link } from "react-router-dom";

import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Col, Container, Row } from "react-bootstrap";


const AlertaPostagem = () => {

    return (
        <Container fluid data-bs-spy="scroll" data-bs-target="#tabela-configuracao-menu" data-bs-offset="0" id="container-tabela-configuracao-menu">
             <Breadcrumb>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active>{'Alerta Postagem'}</Breadcrumb.Item>
            </Breadcrumb>

               <Row>
                <Col sm={12} md={12} lg={{ span: 12, offset: 0 }} className="text-center mt-5 fw-bold fs-6">Pré-Alerta Postagem - Funcionalidade em desenvolvimento</Col>
                </Row>
        </Container>
    )

}

export default AlertaPostagem